// Libraries
import React from 'react';

// Supermove
import {useSupportTools} from '@supermove/analytics';
import {ZendeskType} from '@supermove/analytics/src/services/ZendeskWebWidget/ZendeskWebWidgetTypes';
import {PopoverType} from '@supermove/hooks';
import {openNewTab, List} from '@supermove/utils';

// App
import ActionMenuPopover from '@shared/design/components/ActionMenu/ActionMenuPopover';

const getPopoverActions = ({
  brainfishHandleOpen,
  zendesk,
  referralUtmSource,
  showChatOption,
}: {
  brainfishHandleOpen: () => void;
  zendesk: ZendeskType;
  referralUtmSource: string;
  showChatOption: boolean;
}) => {
  const statusPageUrl = 'http://status.supermove.co/';
  const referalPageUrl = `https://www.supermove.com/referralprogram?utm_source=${referralUtmSource}&utm_medium=customer-help-menu`;

  return [
    {
      actions: [
        {text: 'Ask a question', onPress: brainfishHandleOpen},
        ...List.insertIf(showChatOption, {
          text: 'Chat with support',
          onPress: () => zendesk.open(),
        }),
        {text: 'Status and outages', onPress: () => openNewTab(statusPageUrl)},
      ],
    },
    {
      actions: [{text: 'Refer and earn', onPress: () => openNewTab(referalPageUrl)}],
    },
  ];
};

const HelpCenterPopover = ({
  children,
  helpCenterPopover,
  referralUtmSource,
  showChatOption,
}: {
  children: React.ReactNode;
  helpCenterPopover: PopoverType;
  referralUtmSource: string;
  showChatOption: boolean;
}) => {
  const {handleOpen: brainfishHandleOpen, zendesk} = useSupportTools({isChatVisible: false});

  return (
    <ActionMenuPopover
      popover={helpCenterPopover}
      width={400}
      actions={getPopoverActions({brainfishHandleOpen, zendesk, referralUtmSource, showChatOption})}
      sheetLabel={'Help'}
    >
      {children}
    </ActionMenuPopover>
  );
};

export default HelpCenterPopover;
